<template>
 <div class="app-container">
   <div class="formBox margbot"  ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class=" formItemBox">
               <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" maxlength="8" v-model="searchFrom.vhcNo"></el-input>
              </el-form-item>
              <el-form-item label="审核状态:" prop="auditStatus">
                <el-select v-model="searchFrom.auditStatus" placeholder="请选择">
                  <el-option label="待审核" :value=1></el-option>
                  <el-option label="审核通过" :value=2></el-option>
                  <el-option label="审核未通过" :value=3></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车牌颜色:" prop="vhcNoColour">
                <el-select v-model="searchFrom.vhcNoColour" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in vhcNoColourOptions"
                    :key="index"
                    :label="item.colourName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车辆类型:" prop="vhcTypeId">
                <el-select v-model="searchFrom.vhcTypeId" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in vhcTypeIdOptions"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="道路运输证号:" prop="transportNo" >
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.transportNo "></el-input>
              </el-form-item>
              <el-form-item label="行驶证档案号:" prop="drivingLicense" >
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.drivingLicense "></el-input>
              </el-form-item>
              <el-form-item label="申请时间:" prop="dateTime" >
                <el-date-picker
                  v-model="searchFrom.dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
        </div>
        <div style="margin:10px 0 0 20px;">
              <el-form-item >
                <el-button type="primary"  @click="searchFn" btnCode="000P00VB001" v-if="btnFlg[0]">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="resetForm" btnCode="000P00VB002" v-if="btnFlg[1]">重置</el-button>
              </el-form-item>
              </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' class="tableComent"
       style="width: 100%" height="100%"  center border>
         <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="province"    label="操作" align="center" width="180">
          <template slot-scope="scope">
            <div>
            <!-- 1显示通过/驳回 ，不是1显示记录 -->
            <el-button type="text" size="small" @click="passClick(scope.row)" btnCode="000P00VB003"  v-if="scope.row.auditStatus == '1' && btnFlg[2]">审核</el-button>
            <el-button type="text" size="small" @click="recordClick(scope.row)" btnCode="000P00VB005" v-if="scope.row.auditStatus != '1' && btnFlg[4]">记录</el-button>
            <el-button type="text" size="mini" btnCode=""  v-if="scope.row.auditStatus != '1'" @click="lookImg(scope.row)">查看</el-button>
            <!-- <el-button type="text" size="small" @click="rejectClick(scope.row)" btnCode="000P00VB004" v-if="scope.row.auditStatus == '1' && btnFlg[3]">驳回</el-button> -->
          </div>
          </template>
        </el-table-column>
        <el-table-column property="auditStatus" label="审核状态" >
          <template scope="scope">
            {{[ "待审核", "审核通过", "审核驳回" ][scope.row.auditStatus-1]}}
          </template>
        </el-table-column>
         <el-table-column prop="transportZjxlStatus" width="160"  label="校验是否通过" align="center"  ></el-table-column>
        <el-table-column prop="vhcNo" label="车牌号"  align="center" width="120" ></el-table-column>
        <el-table-column property="vhcClassify" label="车辆所属" >
          <template scope="scope">
            {{[ "单位", "个人" ][scope.row.vhcClassify-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="vehicleTenantName" label="车辆所有人"  align="center" width="270" ></el-table-column>
        <el-table-column prop="noColourName"  label="车牌颜色"  align="center"  width="100"></el-table-column>
        <el-table-column property="vhcTypeName" label="车辆类型"  align="center" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="drivingLicense"    label="行驶证档案号" align="center"  width="180"></el-table-column>
        <el-table-column prop="transportNo"  label="道路运输证号" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="businessLicenseNo"  label="道路运输经营许可证号" align="center" width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="vhcVinNo"  label="车辆识别代号" align="center" width="180"></el-table-column>
        <!-- <el-table-column prop="updateUserName"  label="审核人" align="center" ></el-table-column> -->
        <el-table-column prop="auditTime"  label="申请时间" :formatter="dateTimeFormat"  align="center" width="200"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--点击记录-->
    <el-dialog title="记录"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recordMark"
    width="550px"
    center>
      <span>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in activities" :key="index" :color="activities.length-1 ? '#0bbd87' : ''">
            <p>审核时间：{{activity.ext1}}</p>
            <p>审核人：{{activity.createUserName}}</p>
            <p>审核操作：{{activity.ext2}}</p>
            <p v-if="activity.auditResult">审核结果：{{activity.auditResult}}</p>
          </el-timeline-item>
        </el-timeline>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordMark = false"  size='mini'>取 消</el-button>
      </span>
    </el-dialog>
     <!-- 审核 -->
    <drawer :imgList="imgList"  v-if="drawerFlag"  @destroy="destroy">
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="是否检验通过:" prop="transportZjxlStatus" >
                <div style="width:150px">{{addFrom.transportZjxlStatus}}</div>
              </el-form-item>
              <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder=""  v-model.trim="addFrom.vhcNo" maxlength="20"></el-input>
              </el-form-item>
             <el-form-item label="车辆所属:" prop="vhcClassify">
                <el-select placeholder="请选择" v-model="addFrom.vhcClassify" @change="classifyChange">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆所有人:"  prop="vehicleTenant" v-if="addFrom.vhcClassify==1" key="1">
                <el-select placeholder="请选择"   filterable allow-create
                default-first-option v-model="addFrom.vehicleTenant" value-key="tenantCode" >
                  <el-option
                    v-for="(item,index) in ssdw"
                    :key="index"
                    :label="item.tenantName"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="车辆所有人:" prop="vehicleTenantName" v-if="addFrom.vhcClassify==2" key="2">
                <el-input  placeholder="" v-model="addFrom.vehicleTenantName"  maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="车牌颜色:" class="is-required"  prop="noColour">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.noColour"  >
                  <el-option
                    v-for="item in vhcNoColourOptions"
                    :key="item.id"
                    :label="item.colourName"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆类型:"   prop="vhcType">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.vhcType"  @change="vhcTypeChange">
                  <el-option
                    v-for="item in vhcTypeIdOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="挂车牌号:" prop="trailerNo" v-if="trailerNoIsShow">
                <el-input  placeholder=""  v-model.trim="addFrom.trailerNo" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="行驶证号档案号:" prop="drivingLicense">
                <el-input  placeholder=""  v-number-input.float="0" maxlength="18" v-model="addFrom.drivingLicense"></el-input>
              </el-form-item>
              <el-form-item label="道路运输证号:"  prop="transportNo">
                <el-input  placeholder=""  maxlength="17"  v-model="addFrom.transportNo"></el-input>
              </el-form-item>
               <el-form-item label="道路运输经营许可证号:"  prop="businessLicenseNo">
                <el-input  placeholder=""  maxlength="17"  v-model="addFrom.businessLicenseNo"></el-input>
              </el-form-item>
              <el-form-item label="车辆识别代号:" prop="vhcVinNo">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcVinNo"></el-input>
              </el-form-item>
              <el-form-item label="总质量(吨):" prop="vhcQuality">
                <el-input  placeholder=""  maxlength="10" v-model="addFrom.vhcQuality" v-number-input.float="3"></el-input>
              </el-form-item>
              <el-form-item label="载重(吨):" prop="weight">
                <el-input  placeholder=""  maxlength="10" v-model="addFrom.weight" v-number-input.float="3"></el-input>
              </el-form-item>
              <el-form-item label="外廓尺寸(米):" prop="vhcLongName">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcLongName" v-number-input.float="3"></el-input>
              </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>审核意见</span>
              </h4>
            </div>
            <div style="text-align: center;margin-bottom:20px">
               <el-input type="textarea" style="width: 95%;" v-model="addFrom.nopassReason" onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
            </div>
        </div>
        </el-form>
      </span>
      <div class="footerBox">
        <el-button type="primary" @click="SHsaveFn(2)">通过</el-button>
        <el-button type="primary" @click="SHsaveFn(3)">驳回</el-button>
      </div>
    </drawer>
    <!-- 查看 -->
    <el-dialog title="查看详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="lookImgVisible" @close="closeDialogB" width="1120px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
               <el-form-item label="车牌号:" prop="addFrom">
                 <span>{{addFrom.vhcNo}}</span>
              </el-form-item>
              <el-form-item label="车牌颜色:" prop="vhcNoColour">
               <span>{{addFrom.noColourName}}</span>
             </el-form-item>
              <el-form-item label="车辆类型:" class="is-required"  prop="vhcType">
                 <span>{{addFrom.vhcTypeName}}</span>
             </el-form-item>
             <el-form-item label="挂车牌号:" class="is-required" v-if="trailerNoIsShow">
                 <span>{{addFrom.trailerNo}}</span>
             </el-form-item>
               <el-form-item label="能源类型:"  prop="energyType">
                 <span>{{addFrom.energyName}}</span>
             </el-form-item>
             <el-form-item label="所属单位/个人:" prop="vehicleTenantName" label-width="140">
              <span>{{addFrom.vehicleTenantName}}</span>
              </el-form-item>
             <el-form-item label="使用性质:"  prop="purpose">
               <span>{{addFrom.purposeName}}</span>
             </el-form-item>
             <el-form-item label="排放标准:"  prop="standards">
                <span>{{addFrom.standardsName}}</span>
             </el-form-item>
              <el-form-item label="行驶证号:" prop="drivingLicense">
                 <span>{{addFrom.drivingLicense}}</span>
              </el-form-item>
              <el-form-item label="总质量(吨):" prop="vhcQuality">
                 <span>{{addFrom.vhcQuality}}</span>
              </el-form-item>
              <el-form-item label="载重(吨):" prop="weight">
                 <span>{{addFrom.weight}}</span>
              </el-form-item>
              <el-form-item label="外廓尺寸(米):" prop="vhcLongName">
               <span>{{addFrom.vhcLongName}}</span>
              </el-form-item>
              <el-form-item label="车辆识别代号:" prop="vhcVinNo">
                <span>{{addFrom.vhcVinNo}}</span>
              </el-form-item>
               <el-form-item label="发动机号:"  prop="vhcEngineNo">
                 <span>{{addFrom.vhcEngineNo}}</span>
              </el-form-item>
              <el-form-item label="道路运输证号:"  prop="transportNo">
                <span>{{addFrom.transportNo}}</span>
              </el-form-item>
              <el-form-item label="发证机关:"  prop="issueAuthority">
                <span>{{addFrom.issueAuthority}}</span>
              </el-form-item>
              <el-form-item label="车辆品牌:"  prop="brandModel">
                <span>{{addFrom.brandModel}}</span>
              </el-form-item>
              <el-form-item label="发证日期:" prop="issueDate">
                <el-date-picker
                  v-model="addFrom.issueDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                    placeholder="选择日期时间"
                     :readonly="true"
                ></el-date-picker>
                </el-form-item>
              <el-form-item label="注册日期:" prop="registerDate">
                <el-date-picker
                  v-model="addFrom.registerDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                    placeholder="选择日期时间"
                     :readonly="true"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="道路运输经营许可证号:"  prop="businessLicenseNo" label-width="140">
                 <span>{{addFrom.businessLicenseNo}}</span>
              </el-form-item>
              <el-form-item label="行驶证有效期至:" prop="drivingExpiringDate" label-width="140">
                <el-date-picker
                  v-model="addFrom.drivingExpiringDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                  :readonly="true"
                ></el-date-picker>
                </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>证件信息</span>
              </h4>
            </div>
            <div class="box">
              <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcLicense1Url"
                      :preview-src-list="[addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.transportPhotoUrl,addFrom.transportPhotoUrl2,addFrom.vhcPhoto1Url]">
                    </el-image>
                    <h6>行驶证(正页)</h6>
                </div>
                <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcLicense2Url"
                      :preview-src-list="[addFrom.vhcLicense2Url,addFrom.transportPhotoUrl,addFrom.transportPhotoUrl2,addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url]">
                    </el-image>
                    <h6>行驶证(副页)</h6>
                </div>
                <div class="imgBox">
                   <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.transportPhotoUrl"
                      :preview-src-list="[addFrom.transportPhotoUrl,addFrom.transportPhotoUrl2,addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url]">
                    </el-image>
                    <h6>道路运输证(正页)</h6>
                </div>
                <div class="imgBox">
                   <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.transportPhotoUrl2"
                      :preview-src-list="[addFrom.transportPhotoUrl2,addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.transportPhotoUrl]">
                    </el-image>
                    <h6>道路运输证(副页)</h6>
                </div>
                <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcPhoto1Url"
                      :preview-src-list="[addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.transportPhotoUrl,addFrom.transportPhotoUrl2]">
                    </el-image>
                    <h6>车头照片</h6>
                </div>
            </div>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookImgVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  listByCheck, // 列表查询
  vehicleTypeList, // 车辆类型
  dictionary, // 数据字典
  updateCheckData, // 驳回/通过
  zzauditHistoryList, // 记录
  cVhcNoColour // 车辆颜色
} from '@/api/consignment'
import { getAllTenantDataBySomeData } from '@/api/soc-customer'
import { getCVehicleInfoAllByDriverId, getStatementByVchId } from '@/api/vgs-driver2.0'
import drawer from '@/views/consignment/registerAttestation/drawer.vue'
export default {
  components: {
    drawer
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        auditStatus: 1
      },
      total: 0,
      loading: 'false',
      zzauditStatusOptions: [], // 审核状态
      vhcNoColourOptions: [],
      vhcTypeIdOptions: [],
      // 记录
      activities: [],
      recordMark: false,
      drawerFlag: false,
      addFrom: {},
      carList: [],
      ssdw: [],
      vehicleSS: [
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      imgList: [],
      rules: {
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        noColour: [
          { required: true, message: '请选择车牌颜色', trigger: ['blur', 'change'] }
        ],
        vehicleTenant: [
          { required: true, message: '请选择车辆所有人', trigger: 'blur' }
        ],
        vehicleTenantName: [
          { required: true, message: '请输入车辆所有人', trigger: 'blur' }
        ],
        vhcQuality: [
          { required: true, message: '请输入总质量', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入载重', trigger: 'blur' }
        ],
        vhcLongName: [
          { required: true, message: '请输入外廓尺寸', trigger: 'blur' }
        ],
        vhcType: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
        vhcClassify: [{ required: true, message: '请选择车辆所属', trigger: ['blur', 'change'] }],
        drivingLicense: [{ required: true, message: '行驶证号档案号', trigger: 'blur' }],
        vhcVinNo: [{ required: true, message: '请输入车辆识别代号', trigger: 'blur' }],
        transportNo: [{ required: true, message: '请输入道路运输证号', trigger: 'blur' }],
        businessLicenseNo: [{ required: true, message: '请输道路运输经营许可证号', trigger: ['blur'] }],
        trailerNo: [{ required: true, message: '请输入挂车牌号', trigger: 'blur' }]
      },
      btnFlg: [],
      btnIdArr: ['000P00VB001', '000P00VB002', '000P00VB003',
        '000P00VB004', '000P00VB005'],
      lookImgVisible: false,
      trailerNoIsShow: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/registerAttestation/vehicleCheck')
    // this.dictionary()
    this.getList()
    this.vehicleTypeList()
    this.getCarColor()
    getAllTenantDataBySomeData().then(res => {
      this.ssdw = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 车辆类型切换
    vhcTypeChange (e) {
      console.log(e, '车辆类型')
      if (e.name == '重型半挂牵引车' || e.name == '重型全挂牵引车' || e.name == '重型集装箱半挂车' || e.name == '重型集装箱全挂车') {
      	this.trailerNoIsShow = true
      } else {
      	this.trailerNoIsShow = false
      }
    },
    // 所属切换
    classifyChange () {
      if (this.addFrom.vhcClassify == 2) {
        this.$set(this.addFrom, 'vehicleTenantName', '')
        this.$set(this.addFrom, 'vehicleTenantCode', '')
      }
    },
    // 审核
    passClick (row) {
      this.addFrom = { ...row }
      this.drawerFlag = true
      this.$set(this.addFrom, 'nopassReason', '')
      if (row.vhcTypeId) {
        this.$set(this.addFrom, 'vhcType', { id: row.vhcTypeId, name: row.vhcTypeName, code: row.vhcTypeCode })
      }
      if (row.noColourId) {
        this.$set(this.addFrom, 'noColour', { id: row.noColourId, colourName: row.noColourName, colourCode: row.noColourCode })
      }
      if (this.addFrom.vhcClassify == 1) {
        if (row.vehicleTenantCode == '') {
          this.$set(this.addFrom, 'vehicleTenant', row.vehicleTenantName)
        } else {
          this.$set(this.addFrom, 'vehicleTenant', { tenantCode: row.vehicleTenantCode, tenantName: row.vehicleTenantName })
        }
      }
      this.imgList = []
      if (row.transportPhotoUrl != '') {
        this.imgList.push({ ImgUrl: row.transportPhotoUrl, name: '道路运输证(正页)' })
      }
      if (row.transportPhotoUrl2 != '') {
        this.imgList.push({ ImgUrl: row.transportPhotoUrl2, name: '道路运输证(副页)' })
      }
      if (row.vhcLicense1Url != '') {
        this.imgList.push({ ImgUrl: row.vhcLicense1Url, name: '行驶证主页' })
      }
      if (row.vhcLicense2Url != '') {
        this.imgList.push({ ImgUrl: row.vhcLicense2Url, name: '行驶证副页' })
      }
      if (row.vhcPhoto1Url != '') {
        this.imgList.push({ ImgUrl: row.vhcPhoto1Url, name: '车头照片' })
      }
      if (row.vhcTypeName == '重型半挂牵引车' || row.vhcTypeName == '重型全挂牵引车' || row.vhcTypeName == '重型集装箱半挂车' || row.vhcTypeName == '重型集装箱全挂车') {
      	this.trailerNoIsShow = true
      } else {
      	this.trailerNoIsShow = false
      }
    },
    destroy () {
      this.drawerFlag = false
    },
    getVhcQualityFlag (str) {
      let index = str.toString().indexOf('.') + 1
      let before = str.toString().substring(0, index - 1)
      // let after = str.substring(index)
      if (before.length > 2) {
        this.$alert('重量小数点前保留2位', '系统提示')
        return false
      }
      return true
    },
    SHsaveFn (n) {
      if (this.addFrom.vhcQuality) {
        if (!this.getVhcQualityFlag(this.addFrom.vhcQuality)) { return }
      }
      if (this.addFrom.weight) {
        if (!this.getVhcQualityFlag(this.addFrom.weight)) { return }
      }
      if (Number(this.addFrom.vhcQuality) > 99) {
        this.$alert('重量整数位不能大于2位', '系统提示')
        return
      }
      if (Number(this.addFrom.weight) > 41) {
        this.$alert('载重不能大于41吨', '系统提示')
        return
      }
      if (n == 3) {
        if (this.addFrom.nopassReason) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateCheckData({
            // 驳回传3  通过传2
            nopassReason: this.addFrom.nopassReason,
            id: this.addFrom.id,
            auditStatus: '3'
          }).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.drawerFlag = false
            this.getList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          this.$alert('请输入驳回原因', '系统提示')
        }
      } else {
        this.$refs.addFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.addFrom.auditStatus = 2
            if (this.addFrom.vhcType) {
              this.addFrom.vhcTypeId = this.addFrom.vhcType.id
              this.addFrom.vhcTypeName = this.addFrom.vhcType.name
              this.addFrom.vhcTypeCode = this.addFrom.vhcType.code
            }
            if (this.addFrom.noColour) {
              this.addFrom.noColourName = this.addFrom.noColour.colourName
              this.addFrom.noColourId = this.addFrom.noColour.id
              this.addFrom.noColourCode = this.addFrom.noColour.colourCode
            }
            if (this.addFrom.vhcClassify == 1) {
              if (typeof (this.addFrom.vehicleTenant) == 'string') {
                this.addFrom.vehicleTenantName = this.addFrom.vehicleTenant
                this.addFrom.vehicleTenantCode = ''
              } else {
                this.addFrom.vehicleTenantName = this.addFrom.vehicleTenant.tenantName
                this.addFrom.vehicleTenantCode = this.addFrom.vehicleTenant.tenantCode
              }
            }
            updateCheckData(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.drawerFlag = false
              this.getList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      }
    },
    // 点击记录
    recordClick (row) {
      this.title = '记录'
      this.recordMark = true
      zzauditHistoryList({
        drivercarId: row.id,
        drivercarFlg: '2'
      }).then(res => {
        this.activities = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取审核状态下拉框数据
    dictionary () {
      dictionary({
        groupNo: 'zzaudit_status'
      }).then(res => {
        this.zzauditStatusOptions = res.zzaudit_status
        this.zzauditStatusOptions.forEach((item, index) => {
          if (item.itemNo == '1') {
            this.searchFrom.auditStatus = item.itemNo
          }
        })
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取车辆类型下拉框
    vehicleTypeList () {
      vehicleTypeList().then(res => {
        this.vhcTypeIdOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    getCarColor () {
      cVhcNoColour().then(res => {
        this.vhcNoColourOptions = res
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.dateTime) {
        this.searchFrom.startTime = this.searchFrom.dateTime[0]
        this.searchFrom.endTime = this.searchFrom.dateTime[1]
      }
      this.loading = true
      listByCheck(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.$previewRefresh()
      }).catch(err => {
        this.loading = false
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    // 查看图片
    lookImg (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      if (this.addFrom.vhcTypeName == '重型半挂牵引车' || this.addFrom.vhcTypeName == '重型全挂牵引车' || this.addFrom.vhcTypeName == '重型集装箱半挂车' || this.addFrom.vhcTypeName == '重型集装箱全挂车') {
        this.trailerNoIsShow = true
      } else {
        this.trailerNoIsShow = false
      }
      if (row.vhcClassify == 1) {
        getStatementByVchId({ vhcId: row.id }).then(res => {
          this.lookImgVisible = true
        })
      } else {
        this.lookImgVisible = true
      }
    },
    closeDialogB () {}
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.box{
  display: flex;
  flex-wrap: wrap;
  .imgBox{
    display: flex;
      margin-right:30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
</style>
